"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13 .3a.7.7 0 0 1 .7.7v1.3H15a.7.7 0 1 1 0 1.4h-1.3V5a.7.7 0 1 1-1.4 0V3.7H11a.7.7 0 1 1 0-1.4h1.3V1a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m9.006 2.778-.113-.096a3.09 3.09 0 0 0-3.506-.251C4.482 2.973 3.994 3.77 4 4.854q.005.935.002 1.87L4 7.574v.702l.002 2.106q-.001.21.025.416a3.4 3.4 0 0 0 1.251 2.227c.938.774 2.022 1.078 3.222.943 1.03-.116 1.914-.547 2.615-1.326.554-.616.871-1.343.877-2.18q.01-1.794.006-3.588a4 4 0 0 1-1.383-.662v4.137q0 .153-.025.303c-.097.577-.399 1.03-.853 1.38-.523.406-1.125.578-1.778.57-.61-.007-1.175-.172-1.666-.545-.598-.455-.917-1.05-.913-1.823.006-1.283.004-2.565.003-3.848V4.8c0-.389.146-.716.43-.967.535-.472 1.15-.544 1.803-.305.502.183.927.675.92 1.361-.012 1.158-.01 2.315-.008 3.473l.002 1.344q.002.095-.015.19c-.032.18-.13.307-.311.338a1 1 0 0 1-.298-.006.28.28 0 0 1-.23-.188 1 1 0 0 1-.06-.31q-.004-1.654-.004-3.305V5.104a1 1 0 0 0-.022-.214.685.685 0 0 0-.767-.523.695.695 0 0 0-.596.7q-.004 2.369 0 4.738c.002.4.116.771.347 1.1.587.836 1.73.936 2.466.482.598-.368.869-.93.87-1.625q.005-1.805.003-3.61v-.608a3.98 3.98 0 0 1-.908-2.766"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AddAttachmentIcon16.js.map